<template>
  <div>
    <div v-show="loading_avaliacao === false" class="row avaliacao-wrapper">
      <div class="texts-wrapper">
        <h4>Como você avalia este procedimento de auto-recadastramento?</h4>
      </div>
      <div class="boxes-wrapper" style="overflow: auto;">
        <div @click="setRating(5)" id="rating_5" class="resultadoAV tooltipped" :class="{'green darken-3' : Object.keys(avaliacao_data).length === 0 || avaliacao_data.aval === '5'}" data-position="bottom" data-delay="50" data-tooltip="Estou totalmente satisfeito">
          <p id="av_5"><i class="material-icons">sentiment_very_satisfied</i></p>
        </div>
        <div @click="setRating(4)" id="rating_4" class="resultadoAV tooltipped" :class="{'light-green darken-3' : Object.keys(avaliacao_data).length === 0 || avaliacao_data.aval === '4'}" data-position="bottom" data-delay="50" data-tooltip="Estou satisfeito">
          <p id="av_4"><i class="material-icons">sentiment_satisfied</i></p>
        </div>
        <div @click="setRating(3)" id="rating_3" class="resultadoAV tooltipped" :class="{'lime darken-1' : Object.keys(avaliacao_data).length === 0 || avaliacao_data.aval === '3'}" data-position="bottom" data-delay="50" data-tooltip="Estou insatisfeito">
          <p id="av_3"><i class="material-icons">sentiment_neutral</i></p>
        </div>
        <div @click="setRating(2)" id="rating_2" class="resultadoAV tooltipped" :class="{'orange darken-3' : Object.keys(avaliacao_data).length === 0 || avaliacao_data.aval === '2'}" data-position="bottom" data-delay="50" data-tooltip="Estou muito insatisfeito">
          <p id="av_2"><i class="material-icons">sentiment_dissatisfied</i></p>
        </div>
        <div @click="setRating(1)" id="rating_1" class="resultadoAV tooltipped" :class="{'red darken-3' : Object.keys(avaliacao_data).length === 0 || avaliacao_data.aval === '1'}" data-position="bottom" data-delay="50" data-tooltip="Estou totalmente insatisfeito">
          <p id="av_1"><i class="material-icons">sentiment_very_dissatisfied</i></p>
        </div>
      </div>
      <div class="step-actions">
          <button type="button" class="waves-effect waves-dark btn-flat" @click="goToPrevStep">Anterior</button>
          <button @click="submitStep" type="button" class="waves-effect waves-dark btn">Próximo</button>
      </div>
    </div>
    <div v-show="loading_avaliacao === true">
      <loading />
    </div>
  </div>
</template>
<script>
  import Loading from '@/components/Loading.vue'
  import axios from 'axios'
  import { CONFIG } from '@/config/config.js'
  import SocialService from '@/services/social-service.js'

  let socialService = new SocialService(CONFIG.URL_SOCIAL_API_V2)

  export default {
    name: 'Avaliacao',
    components: {
      loading: Loading
    },
    props: {
      step_incomplete: Number,
      prev_step_index: {
        type: Number,
        default: 4
      }
    },
    data (){
      return {
        loading_avaliacao: false,
        meta: this.$store.state.meta.data,
        pf_id: this.$store.state.user.pfId,
        step_completed: false,
        error: null,
        avaliacao_data: {},
      }
    },
    methods: {
      getRating() {
        this.loading_avaliacao = true
        axios.get(`${CONFIG.URL_RECAD_API_V2}/v1/aval/${this.pf_id}/`)
        .then(response => {
          this.avaliacao_data = response.data.data.RecadAPI
        })
        .catch(error => {
          if (typeof error === 'object' && 'response' in error && error.response.status !== 404) {
            console.error(error)
          }
        })
        .finally(() => {
          this.loading_avaliacao = false
          this.step_completed = true
        })
      },
      async setRating(id) {
        this.loading_avaliacao = true
        axios.post(`${CONFIG.URL_RECAD_API_V2}/v1/aval/`, {
          "pf_id": this.pf_id,
          "aval": id,
          "aval_segurado": true,
          "device": await socialService.getDeviceInfo()
        })
        .then(response => {
          M.toast({html: "Obrigado por sua avaliação!"})
          this.getRating()
        })
        .catch(error => {
          M.toast({html: "Ops! Não foi possível realizar esta operação...tente novamente em instantes."})
        })
        .finally(() => {
          this.loading_avaliacao = false
        })
      },
      submitStep() {
        this.$emit('moveNextStep', {step: 5, completed: true})
      },
      goToPrevStep() {
        this.$emit('goToStep', this.prev_step_index)
      },
      verificaStatusPasso(){
        return true
      },
      initStep(){
        M.Tooltip.init(document.querySelectorAll('.tooltipped'))
        this.getRating()
      },
      initFields(){
        M.Tooltip.init(document.querySelectorAll('.tooltipped'))
      }
    },
    mounted(){
      this.getRating()
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/steps/Avaliacao.vue